import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';

import {TextCheckbox} from 'front-onceforall-core';

const TRAD_ROOT = 'subscriptions.questions.shareCompliance';

function ShareComplianceQuestion(props) {
  return (
    <div className='row align-items-center'>
      <div className='col-6 d-flex justify-content-end'>
        <strong><Translate value={`${TRAD_ROOT}.title`}/></strong>
      </div>
      <div className='ml-4'>
        <TextCheckbox
          label={I18n.t(`${TRAD_ROOT}.response.yes`)}
          checked={props.answer}
          onChange={() => props.setAnswer(true)}
          name="shareCompliance-yes"
        />
      </div>
      <div>
        <TextCheckbox
          label={I18n.t(`${TRAD_ROOT}.response.no`)}
          checked={!props.answer && props.answer != null}
          onChange={() => props.setAnswer(false)}
          name="shareCompliance-no"
        />
      </div>
    </div>
  );
}

ShareComplianceQuestion.defaultProps = {
  answer: null
};

ShareComplianceQuestion.propTypes = {
  setAnswer: PropTypes.func.isRequired,
  answer: PropTypes.bool
};

export default ShareComplianceQuestion;
